import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TriggerAction } from '@shared/actions';
import { ButtonOutline } from '@shared/buttons/button-outline/button-outline.data';
import { StateManagerProjectService } from '@state-manager/state-manager-project.service';
import { CornerstoneService } from '@viewer/cornerstone.service';
import {
  CompositeKeys,
  HotKey,
  HotKeySettings,
  SaveComponentKeyActionName,
} from '@viewer/data';
import { combineLatest, map, Subject, takeUntil } from 'rxjs';
import { KeyInteractionService } from 'src/app/interaction';

@Component({
  selector: 'app-save-action',
  templateUrl: 'save-action.component.html',
  styleUrls: ['save-action.component.scss'],
})
export class SaveActionComponent implements OnInit, OnDestroy {
  @Input() useHotKeys = true;

  readonly ButtonOutline = ButtonOutline;

  public saveAction: TriggerAction;
  public saveActionHotkey = 'Ctrl+S';

  private _unsubscribe$ = new Subject();

  constructor(
    public stateManagerProjectService: StateManagerProjectService,
    private _cornerstoneService: CornerstoneService,
    private _keyInteractionService: KeyInteractionService
  ) {
    this.saveAction = new TriggerAction('', 'Actions.SAVE', () => {
      this._cornerstoneService.saveMask(() => {
        this.stateManagerProjectService.isChangesBetweenMasks = false;
      });
    });
    this.saveAction.isEnable = () =>
      combineLatest([
        this.stateManagerProjectService.isViewerLoaded$,
        this.stateManagerProjectService.isSaveActionDisabled$,
        this.stateManagerProjectService.isDisabledAllToolsForChangeMask$,
      ]).pipe(
        map(
          ([
            isViewerLoaded,
            isSaveActionDisabled,
            isDisabledAllToolsForChangeMask,
          ]) =>
            isViewerLoaded &&
            !isSaveActionDisabled &&
            !isDisabledAllToolsForChangeMask
        )
      );
  }

  ngOnInit(): void {
    if (this.useHotKeys) {
      this._initializeHotKeys();
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next(undefined);
    this._unsubscribe$.complete();
  }

  private _initializeHotKeys(): void {
    this._keyInteractionService
      .initializeHotKey(
        HotKey.S,
        new HotKeySettings<SaveComponentKeyActionName>({
          keyActionName: 'SaveTrigger',
          compositeKeys: [CompositeKeys.Ctrl],
        })
      )
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(() => {
        this.saveAction.trigger();
      });
  }
}
